var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"elevation":"3"}},[_c('v-toolbar',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Delivery information for Sofie Account Number: "+_vm._s(_vm.sofieId))])],1),_c('shipped-to',{attrs:{"ship-to-address-info":_vm.shipToAddressInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }